<template>
    <transition name="slide">
        <div class="drawer-modal" v-show="show">
            <div class="drawer-modal-body">
                <div class="drawer-modal-heading">
                        <button class="drawer-modal-close-button" @click="onClose">
                            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.707.293L10 8.585 18.293.293a1 1 0 011.414 1.414L11.415 10l8.292 8.293a1 1 0 01-1.414 1.414L10 11.415l-8.293 8.292a1 1 0 11-1.414-1.414L8.585 10 .293 1.707A1 1 0 111.707.293z" fill="#FFF" fill-rule="evenodd"/>
                            </svg>
                        </button>
                </div>
                <div class="drawer-modal-content">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "DrawerModal",
    props: {
        value: Boolean
    },
    data() {
        return {
            show: this.value
        }
    },
    watch: {
        value(newValue) {
            this.show = newValue;
        }
    },
    methods: {
        onClose() {
            this.$emit("input", false);
        }
    }
}
</script>

<style lang="scss" scoped>
    .slide-enter-active {
        animation: slide-in-bottom 0.8s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    }

    .slide-leave-active {
        animation: slide-out-bottom 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    }

    @keyframes slide-in-bottom {
        0% {
            bottom: -100%;
        }

        100% {
            bottom: 0%;
        }
    }

    @keyframes slide-out-bottom {
        0% {
            bottom: 0%;
        }
        100% {
            bottom: -100%;
        }
    }


    .drawer-modal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.65);
        z-index: 999999;

        &-body {
            background-color: #252525;
            color: white;
            padding: 15px 15px 50px 15px;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;

            @media (min-width: 580px) {
                margin: 0;
                width: 100%;
            }
        }

        &--open {
            .drawer-modal-body {
                bottom: 0;
            }
        }

        &-heading {
            display: flex;
            margin-bottom: 25px;
            justify-content: flex-end;
        }

        &-close-button {
            display: flex;
            align-items: center;
            -webkit-appearance: none;
            background-color: transparent;
            border: none;
            cursor: pointer;
            outline: white;
        }

        &-content {
            font-size: 16px;
        }
    }
</style>